"use client";

import { useId } from "react";
import { motion } from "motion/react";
import { Tabs } from "radix-ui";
import { cx } from "cva";
import {
  segmentedControlIndicatorStyles,
  segmentedControlListStyles,
  segmentedControlTriggerStyles,
} from "./styles/segmented-control.styles";
import type { SegmentedControlProps } from "./types/segmented-control.types";

export function SegmentedControl<TValue extends string = string>(props: SegmentedControlProps<TValue>) {
  const { options, value, onValueChange, ariaLabel, size, className } = props;
  const layoutId = useId();

  return (
    <Tabs.Root value={value} onValueChange={(next) => onValueChange(next as TValue)}>
      <Tabs.List aria-label={ariaLabel} className={cx(segmentedControlListStyles({ size }), className)}>
        {options.map((option) => {
          const isActive = option.value === value;
          return (
            <Tabs.Trigger key={option.value} value={option.value} className={segmentedControlTriggerStyles({ size })}>
              {isActive && (
                <motion.span
                  aria-hidden="true"
                  layoutId={layoutId}
                  className={segmentedControlIndicatorStyles({ size })}
                  transition={{ type: "spring", bounce: 0.15, duration: 0.4 }}
                />
              )}
              <span className="relative z-1">{option.label}</span>
            </Tabs.Trigger>
          );
        })}
      </Tabs.List>
    </Tabs.Root>
  );
}

SegmentedControl.displayName = "SegmentedControl";
